import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hocus:bg-lighten-xs flex w-full cursor-pointer items-center rounded py-1 px-5" }

import { PropType } from 'vue';
import { VueAttributeClass } from '@/types/attributes-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsAvailabilityItem',
  props: {
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([props.class, "flex rounded"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})